import React, { useState, useEffect, useRef } from "react";
import {
  Logo,
  AccountSetting,
  Managebenificary,
  LogOutIcon,
  ManageBeni,
} from "./../../Public/assets/index";
import Footer from "../Footer";
import { useMatch, useNavigate } from "react-router-dom";
import { getSession } from "./../../axios.config";
import { logout } from "./../../api";
import { useOverview } from "./../../hooks";
import { clearSession, getInitials } from "./../../Utils/helperFunction";
import { useTheme } from "../../Context/Theme";

const Layout = ({
  children,
  noToggle = true,
  notVerified = false,
  footer = true,
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const user = JSON.parse(getSession("userId"));
  const USERName = user?.name;
  const { getThemeLogo } = useTheme();
  const dynamicLogo = getThemeLogo();

  const isDashboard = useMatch("/homeVerification");

  const handleLogout = async () => {
    await logout();
    clearSession();
    navigate("/");
  };
  const { useGlobalAccount } = useOverview();

  const { data: globalData } = useGlobalAccount(noToggle);

  const menuItems = [
    {
      icon: AccountSetting,
      text: "Account Settings",
      onClick: () => {
        navigate("/account");
      },
    },
    {
      icon: ManageBeni,
      text: "Manage Beneficiaries",
    },
    {
      icon: Managebenificary,
      text: "Reports & Statement",
    },
    {
      icon: LogOutIcon,
      text: "Logout",
      className: " text-[#FF0004] overflow-hidden",
      onClick: handleLogout,
    },
  ];
  const notVerifiedMenuItems = [
    {
      icon: AccountSetting,
      text: "Account Settings",
      onClick: () => {
        navigate("/account");
      },
    },
    {
      icon: LogOutIcon,
      text: "Logout",
      className: " text-[#FF0004] overflow-hidden",
      onClick: handleLogout,
    },
  ];

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <nav className="w-full bg-white shadow-sm fixed top-0 z-50">
        <div className="h-[63px] lg:h-[80px] px-6 xl:px-40 flex items-center justify-between">
          <div
            className="flex items-center space-x-2"
            onClick={() => {
              if (!isDashboard) {
                navigate(-1);
              }
              // isDashboard ? navigate(-1) : navigate("/");
            }}
          >
            <img
              src={Logo}
              alt=""
              className=" !w-[75px] md:!w-[135px] lg:w-auto hover:cursor-pointer !min-w-[100px] !min-h-[30px]"
            />
          </div>

          {noToggle && (
            <div className="flex items-center space-x-4 relative">
              {/* <button className="p-2 hover:bg-gray-100 rounded-full">
                <img src={bell} alt="" className="h-5 w-5 text-gray-600" />
              </button> */}
              <div
                className="flex items-center space-x-2 relative hover:pointer"
                onClick={() => setDropdownOpen((prev) => !prev)}
                ref={dropdownRef}
              >
                <button className="font-geomanistMedium text-greyish bg-greyShade rounded-full p-2">
                  {getInitials(USERName)}
                </button>
                <svg
                  className="w-4 h-4 text-gray-600 hover:pointer"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>

              {dropdownOpen && (
                <div
                  className="absolute top-12 right-0 rounded-[10px] shadow-headerShadow"
                  ref={dropdownRef}
                >
                  <div className="w-[232px] bg-white rounded-lg overflow-hidden shadow-lg">
                    {!notVerified && (
                      <div className="px-[10px] pt-4 pb-1 gap-0.5">
                        <div className="text-[#475467] leading-[20px] font-geomanistBold text-[16px]">
                          {USERName}
                        </div>
                        <div className="leading-[28px] text-[16px] text-[#767C8F]">
                          ******{globalData?.data?.vendorAccountNo?.slice(-4)}
                        </div>
                      </div>
                    )}
                    {!notVerified ? (
                      <div className="">
                        {menuItems.map((item, index) => (
                          <button
                            key={index}
                            className={`w-full border-t flex items-center gap-2 py-4 pl-[10px] hover:bg-gray-50 font-geomanistBold text-left text-[16px] leading-[21px] text-[#717789] ${
                              item.className || ""
                            }`}
                            onClick={item.onClick}
                          >
                            <img src={item.icon} alt="" />
                            {item.text}
                          </button>
                        ))}
                      </div>
                    ) : (
                      <div className="">
                        {notVerifiedMenuItems.map((item, index) => (
                          <button
                            key={index}
                            className={`w-full border-t flex items-center gap-2 py-4 pl-[10px] hover:bg-gray-50 font-geomanistBold text-left text-[16px] leading-[21px] text-[#717789] ${
                              item.className || ""
                            }`}
                            onClick={item.onClick}
                          >
                            <img src={item.icon} alt="" />
                            {item.text}
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </nav>
      {children}
      {footer && <Footer />}
    </>
  );
};

export default Layout;
